import React from 'react';
import PropTypes from 'prop-types';

const RealtimeInfo = ({
  dueTimeDisplay, arrivalStatusDisplay, cancelledDisplay, stopsAwayDisplay, scheduledTimeDisplay,
}) => (
  <div className="movement-info-realtime-info-container" aria-hidden="true">
    <div className="movement-info-time-stop-container">
      {dueTimeDisplay && <span className="movement-info-due-time">{dueTimeDisplay}</span>}
      {!cancelledDisplay && arrivalStatusDisplay && <span className="movement-info-arrival">{arrivalStatusDisplay}</span>}
      {scheduledTimeDisplay && <span className="movement-info-scheduled-time">{scheduledTimeDisplay}</span>}
      {dueTimeDisplay && stopsAwayDisplay && <span>{`${stopsAwayDisplay}`}</span>}
    </div>
    {cancelledDisplay && <span className="movement-info-cancelled-display">{cancelledDisplay}</span>}
  </div>
);
RealtimeInfo.propTypes = {
  dueTimeDisplay: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  arrivalStatusDisplay: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  cancelledDisplay: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  stopsAwayDisplay: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  scheduledTimeDisplay: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};
RealtimeInfo.defaultProps = {
  dueTimeDisplay: false,
  arrivalStatusDisplay: false,
  cancelledDisplay: false,
  stopsAwayDisplay: false,
  scheduledTimeDisplay: false,
};

export default RealtimeInfo;